import { concat } from 'lodash/fp';

import getLabelsById from '../../getLabelsById';

import options from './options';
import commercialOptions from './commercialOptions';

export default getLabelsById(concat(options, commercialOptions));
